import React, { useState } from "react";

function Popup({ makeBtnClick, message }) {
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    if (!message.fullName || !message.email || !message.msg) {
      alert("Please enter a message");
    } else {
      setIsOpen(!isOpen);
      isOpen && makeBtnClick();
    }
  };

  return (
    <div className="relative">
      <button
        onClick={togglePopup}
        disabled={!message.fullName || !message.email}
        className={`${
          message.fullName && message.email && message.msg
            ? "bg-common-red"
            : "bg-slate-400"
        }  hover:${
          message.fullName && message.email && message.msg
            ? "bg-red-700 cursor-pointer"
            : "bg-slate-400 cursor-not-allowed"
        } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
      >
        Send Message
      </button>
      {isOpen && (
        <div className="fixed inset-0 z-10 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
          <div className="relative w-auto max-w-3xl mx-auto my-6">
            <div className="bg-white rounded-lg shadow-lg">
              <div className="p-4">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold">Your MSG Status</h3>
                  <button
                    onClick={togglePopup}
                    className="text-gray-500 hover:text-gray-700 focus:outline-none"
                  >
                    <svg
                      className="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M13.414 12l3.293 3.293a1 1 0 01-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 01-1.414-1.414L10.586 12 7.293 8.707a1 1 0 011.414-1.414L12 10.586l3.293-3.293a1 1 0 111.414 1.414L13.414 12z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <p className="text-sm text-gray-700">
                  Message has been send to Mahin successfully! Thank you.
                </p>
              </div>
              <div className="flex justify-end p-4">
                <button
                  onClick={togglePopup}
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                  DONE
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Popup;
